/**
 * Lead Sniper — sends a silent Discord notification when a user
 * searches for (or submits their info for) a Social Kit on the landing page.
 *
 * Fails silently so it never disrupts the visitor's experience.
 */

interface BusinessLead {
  name: string;
  address: string;
  rating?: number;
  totalRatings?: number;
}

interface ContactInfo {
  name: string;
  email: string;
}

export async function sendDiscordAlert(business: BusinessLead, contact?: ContactInfo): Promise<void> {
  try {
    const webhookUrl = import.meta.env.VITE_DISCORD_WEBHOOK_URL;
    if (!webhookUrl) return;

    const ratingDisplay = business.rating
      ? `⭐ ${business.rating} (${business.totalRatings ?? '?'} reviews)`
      : 'No rating yet';

    const isFullLead = Boolean(contact?.name && contact?.email);

    const fields = [
      { name: '🏢 Business Name', value: business.name, inline: false },
      { name: '📍 Location', value: business.address || 'N/A', inline: true },
      { name: '⭐ Current Rating', value: ratingDisplay, inline: true },
    ];

    if (isFullLead) {
      fields.push(
        { name: '👤 Contact Name', value: contact!.name, inline: true },
        { name: '📧 Email', value: contact!.email, inline: true },
      );
    }

    const payload = {
      embeds: [
        {
          title: isFullLead ? '🚀 Social Kit Lead — FULFILL NOW' : '🎯 Search Lead Detected',
          color: isFullLead ? 0xf59e0b : 0x10b981, // amber for full leads, emerald for searches
          fields,
          footer: { text: isFullLead ? 'Visto Social Kit Lead — manual fulfillment needed' : 'Visto Lead Sniper' },
          timestamp: new Date().toISOString(),
        },
      ],
    };

    const response = await fetch(webhookUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    console.log('Webhook fired', response.status);
  } catch (error) {
    console.error('Webhook failed', error);
  }
}
